export default function SpacingSmall({ sectionId }) {
return (
<div
id={sectionId}
style={{
height: "var(--padding-sm)",
width: "100%"
}}
/>
);
}